import useDragToScroll from "../../../../../hooks/useDragToScroll";
import { useTranslation } from "react-i18next";
import { useHorizontalScroll } from "../../../../../hooks/useHorizontalScroll";
import SvgIcon from "../../../../../parts/SvgIcon";
import TimeLineItem from "./TimeLineItem";

const titles = {
  front: "Front",
  back: "Back",
  side: "Side",
};
const TimelinePhotos = ({
  listOfPhotos,
  type,
  selectPhotos,
  choosing,
  selectedPhotos,
  expandedList,
  setExpandedList,
  isOnModal,
}) => {
  const { t } = useTranslation("athlete-portal");
  const elRef = useHorizontalScroll("faster");
  const {
    scrollContainerRef,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    handleTouchStart,
    handleTouchMove,
    isDragging,
  } = useDragToScroll(elRef);
  return (
    <div
      className={`${expandedList && expandedList !== type ? "phidden" : ""}`}
    >
      {!isOnModal && (
        <div className="flex gap-2 items-center mb-5">
          <h4>{t(`progressPhotos.${type}`)}</h4>
          <button
            data-button-type="secondary"
            onClick={() =>
              expandedList ? setExpandedList(null) : setExpandedList(type)
            }
          >
            <SvgIcon
              src={
                expandedList
                  ? "/img/new-icons/Zoom-out.svg"
                  : "/img/new-icons/Zoom.svg"
              }
            />
          </button>
        </div>
      )}
      <section
        ref={elRef}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        style={{ cursor: isDragging ? "grabbing" : "grab" }}
      >
        <ul>
          {listOfPhotos &&
            listOfPhotos.length > 0 &&
            listOfPhotos
              .sort((a, b) => a.utcDate - b.utcDate)
              .map((item) => {
                return (
                  <TimeLineItem
                    key={`${item._id}${type}`}
                    stat={item}
                    type={type}
                    choosing={choosing}
                    selectPhotos={selectPhotos}
                    selectedPhotos={selectedPhotos}
                    expandedList={expandedList}
                    isOnModal={isOnModal}
                    dailyStatId={item._id}
                    utcDate={item.utcDate}
                  />
                );
              })}
        </ul>
        {!listOfPhotos ||
          (listOfPhotos.length === 0 && (
            <div>{t("progressPhotos.noData")}</div>
          ))}
      </section>
    </div>
  );
};

export default TimelinePhotos;
